import { useCallback } from 'react';
import useWaApi from './axios/useWaApi';
import { Disaster } from '../store/WaRegionAndDisasterStore';

function useWaDisasterRepo() {
  const { get } = useWaApi();

  const getLatestDisastersRequest = useCallback(async () => {
    try {
      return await get<Disaster>('/api/wa/disasters/latest');
    } catch (error) {
      console.log(error);
      return null;
    }
  }, [get]);

  return {
    getLatestDisastersRequest,
  };
}

export default useWaDisasterRepo;
